import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'cms_carousel',
  components: {
    articleSel: function articleSel() {
      return import('./article_simple_sel_page.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '轮播',
        addFunName: 'cmsCarouselAdd',
        modifyFunName: 'cmsCarouselModify',
        delFunName: 'cmsCarouselDel',
        queryFunName: 'cmsCarouselQuery',
        detailFunName: 'cmsCarouselDetail',
        dicTreeFunName: 'mngDictionaryLowerTree',
        articleDetailFunName: 'cmsArticleSimpleDetail'
      },
      dicData: {
        categoryUpperCode: 'cms_carousel_category',
        configCategorys: [],
        configCategoryOptions: {},
        typeUpperCode: 'cms_carousel_type',
        configTypes: [],
        configTypeOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: '^sort'
      },
      formData: {
        id: null,
        title: null,
        listImage: null,
        category: null,
        type: null,
        busId: null,
        busName: null,
        busHref: null,
        sort: null,
        remark: null
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '请选择类别',
          trigger: 'blur'
        }],
        listImage: [{
          required: true,
          message: '请上传轮播图',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序号不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1-9]\d*$/,
          message: '排序号必须为正整数',
          trigger: 'blur'
        }]
      },
      articleSelData: {
        category: null,
        type: null,
        isShow: false
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.categoryUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCategorys = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configTypeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    articleSel: function articleSel(data) {
      if (data) {
        this.formData.busId = data.id;
        this.formData.busName = data.title;
      }
      this.articleSelData.isShow = false;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.listImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.listImage);
    },
    removeFile: function removeFile() {
      this.formData.listImage = '';
    },
    initFormData: function initFormData(data) {
      var _this3 = this;
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;

      // 文章类型
      if (paramData.category === 'cms_carousel_category_article' && !!paramData.busId) {
        this.$api[this.pageConfig.articleDetailFunName](paramData.busId).then(function (res) {
          if (res.data) {
            _this3.$set(_this3.formData, 'busName', res.data.title);
          }
        });
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this4 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this4.initFormData(res.data);
        _this4.editDialogTitle = _this4.pageConfig.editPageName + '维护';
        _this4.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this5 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this5.$api[_this5.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('删除成功');
            _this5.query();
          } else {
            _this5.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this6 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this6.tableData = res.data || [];
        _this6.totalCount = res.count;
        _this6.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this7 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this7.formData.id) {
            _this7.$api[_this7.pageConfig.modifyFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('编辑成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('编辑失败');
              }
            });
          } else {
            _this7.$api[_this7.pageConfig.addFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('新增成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : '^sort';
      this.query();
    }
  }
};